import ClubExamType from '../../dto/club/ClubExamType';
import Error from '../../model/Error';
import axios from 'axios';

export default class ClubExamTypeRepository {
    static findByClubId(clubId, includeArchived = true) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/exams/types?includeArchived=${includeArchived}`)
                .then((response) => resolve(response.data.data.map((data) => ClubExamType.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static bulkUpdate(clubId, clubExamTypes) {
        const data = { clubExamTypes: clubExamTypes.map((clubExamType) => {
            return {
                id: clubExamType.id,
                title: clubExamType.title,
                colour: clubExamType.colour,
                clubId,
            };
        }) };
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/exams/types`, data)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(examTypeId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/exams/types/${examTypeId}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static archive(examTypeId, archived) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`/club/exams/types/${examTypeId}/archived`, { archived })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
